import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { buildPartialFormDataPayload } from '@/utils/fetch';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

export const UpdateReplyTemplateValidationSchema = z.object({
  templateId: z.string().min(1),
  title: z.string().min(1, 'Template name is required'),
  content: z.string(),
});
export type TUpdateReplyTemplateValidation = z.infer<typeof UpdateReplyTemplateValidationSchema>;
export type TUpdateReplyTemplatePayload = TUpdateReplyTemplateValidation;
export type TUpdateReplyTemplateResponse = ApiResponse<unknown>;

export const updateReplyTemplate = (payload: TUpdateReplyTemplatePayload): Promise<TUpdateReplyTemplateResponse> => {
  const url = `/template/${payload.templateId}`;

  const payloadData = buildPartialFormDataPayload(payload, ['title', 'content']);

  return axiosInstance.patch(url, payloadData);
};

type TUseUpdateReplyTemplateMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof updateReplyTemplate, AxiosErrorCustom>;
};

export const useUpdateReplyTemplateMutation = ({ mutationConfigOptions }: TUseUpdateReplyTemplateMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};
  return useMutation({
    mutationFn: updateReplyTemplate,
    ...restConfigOptions,
  });
};
